export default function isSupported(storage: Storage) {
  try {
    const key = `testing-item-storage`
    storage.setItem(key, key)
    storage.removeItem(key)

    return true
  } catch (e) {
    return false
  }
}
